import { Component, ElementRef, input, Input, NgModule, OnInit, ViewChild, signal, computed } from '@angular/core'

import { WorkflowManagerApiService } from '../../../../_services'
import { ActivatedRoute, Router } from '@angular/router'
import { TreeNode, MessageService } from '@openng/optimus-ui/api'
import { graphic } from 'echarts/core'
import { CommonModule } from '@angular/common'
import { TableModule } from '@openng/optimus-ui/table'
import { OrganizationChartModule } from '@openng/optimus-ui/organizationchart'
import { ProgressBarModule } from '@openng/optimus-ui/progressbar'
import { FieldsetModule } from '@openng/optimus-ui/fieldset'
import { MenuModule } from '@openng/optimus-ui/menu'
import { ButtonModule } from '@openng/optimus-ui/button'
import { SkeletonModule } from '@openng/optimus-ui/skeleton'
import { DockModule } from '@openng/optimus-ui/dock'
import { TreeTableModule } from '@openng/optimus-ui/treetable'
import { PanelModule } from '@openng/optimus-ui/panel'
import { NgxEchartsModule } from 'ngx-echarts'
import { echarts } from '../../../../_shared/echarts-setup'
import { DialogModule, Dialog } from '@openng/optimus-ui/dialog'
import { speedTestModule, SpeedTestComponent } from '../../speedtest/speedtestComponent/speedtest'
import { TooltipModule } from '@openng/optimus-ui/tooltip'
import { BadgeModule } from '@openng/optimus-ui/badge'
import { MessageModule } from '@openng/optimus-ui/message'
import { FormsModule } from '@angular/forms'
import { FuseqTableComponent } from '../../../../FuseQ/fuseq-modules/fuseqTable/fqtable.component'
import { SpeedtestHistoryTableComponent } from '../../../speedTestAWP/speedtest-history-table/speedtest-history-table.component'
import { FqDialogNavComponent } from '../../../../shared/fq-dialog-nav.component'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
interface CiscoEdgeTrafficItem {
  entry_time: number
  rx_kbps: number
  tx_kbps: number
  interface: string
  count: number
}
interface CiscoEdgeTrafficResponse {
  data: CiscoEdgeTrafficItem[]
}
import { OptimUiSharedModule } from '../../../../shared/optimus-ui-shared.module';
@Component({
  selector: 'cisco-edge',
  templateUrl: 'ciscoDetails.component.html',
  styleUrls: ['./ciscoDetails.component.css'],
  imports: [OptimUiSharedModule, CommonModule, FormsModule, FontAwesomeModule, NgxEchartsModule, SpeedTestComponent, SpeedtestHistoryTableComponent, FqDialogNavComponent]
})

export class CiscoDetailsComponent {
  @ViewChild('mySelect') mySelect!: ElementRef
  @Input() showCiscoEdge: boolean = false
  @Input() standalone: boolean = false
  @Input() set deviceUUID (value: string | null) {
    // console.log('Device UUID changed to:', value)
    this._deviceUUID = value
    //  console.log('Device UUID set to:', this._deviceUUID)
    if (value && value !== null) {
      if (value !== this._deviceUUID) {
        this.showCiscoEdge = true
      }
      this.refreshData(value)
    }
  }

  get deviceUUID (): string | null {
    return this._deviceUUID
  }

  private _deviceUUID: string | null = null

  constructor (
    private readonly messageService: MessageService,
    private readonly workflowApiService: WorkflowManagerApiService,
    private readonly route: ActivatedRoute,
    private readonly router: Router
  ) {
  }

  @ViewChild('details') detailsElement!: ElementRef
  @ViewChild('workflow') workflowElement!: ElementRef
  @ViewChild('controllers') controllersElement!: ElementRef
  @ViewChild('tlocs') tlocsElement!: ElementRef
  @ViewChild('circuits') circuitsElement!: ElementRef
  @ViewChild('bfdSessions') bfdSessionsElement!: ElementRef
  @ViewChild('controlConnections') controlConnectionsElement!: ElementRef
  @ViewChild('interfaces') interfacesElement!: ElementRef
  @ViewChild('tasks') tasksElement!: ElementRef
  @ViewChild('switch') switchElement!: ElementRef
  @ViewChild('sensors') sensorsElement!: ElementRef
  @ViewChild('_hardware') hardwareElement!: ElementRef
  @ViewChild('speedtest', { static: false }) speedtestElement!: ElementRef

  items = [
    {
      label: 'Device',
      items: [
        {
          label: 'Workflow',
          icon: 'fa fa-sitemap',
          command: () => {
            this.scrollTo('workflow')
          }
        },
        {
          label: 'Sensors',
          icon: 'fa fa-temperature-high',
          command: () => {
            this.scrollTo('sensors')
          }
        },
        {
          label: 'Details',
          icon: 'fa fa-circle-info',
          command: () => {
            this.scrollTo('details')
          }
        },
        {
          label: 'Controllers',
          icon: 'fa fa-circle-nodes',
          command: () => {
            this.scrollTo('controllers')
          }
        },
        {
          label: 'TLOCs',
          icon: 'fa fa-satellite-dish',
          command: () => {
            this.scrollTo('tlocs')
          }
        },
        {
          label: 'Circuits',
          icon: 'fa fa-tower-broadcast',
          command: () => {
            this.scrollTo('circuits')
          }
        },
        {
          label: 'BFD Sessions',
          icon: 'fa fa-network-wired',
          command: () => {
            this.scrollTo('bfdSessions')
          }
        },
        {
          label: 'Control Connections',
          icon: 'fa fa-house-signal',
          command: () => {
            this.scrollTo('controlConnections')
          }
        },
        {
          label: 'Interfaces',
          icon: 'fa fa-ethernet',
          command: () => {
            this.scrollTo('interfaces')
          }
        },
        {
          label: 'Switch',
          icon: 'fa fa-plug',
          command: () => {
            this.scrollTo('switch')
          }
        },
        {
          label: 'Tasks',
          icon: 'fa fa-list-check',
          command: () => {
            this.detailTab = 'tasks'
            setTimeout(() => this.scrollTo('tasks'))
          }
        },
        {
          label: 'Hardware',
          icon: 'fa fa-cubes',
          command: () => {
            this.scrollTo('hardware')
          }
        },
        {
          label: 'SpeedTest',
          icon: 'fa-solid fa-gauge-high',
          command: () => {
            this.detailTab = 'speedtest-new'
            setTimeout(() => this.scrollTo('speedtest'))
          }
        }
      ]
    }
  ]

  orgChart = signal<TreeNode[]>([])
  rawData = signal<any[]>([])
  chartOption = signal<any>({})
  ciscoEdge = signal<any>(null)
  fakeData = [{ key: 'fake', value: 'fake' }, { key: 'fake2', value: 'fake2' }, { key: 'fake3', value: 'fake3' }, { key: 'fake4', value: 'fake4' }, { key: 'fake5', value: 'fake5' }, { key: 'fake6', value: 'fake6' }, { key: 'fake7', value: 'fake7' }, { key: 'fake8', value: 'fake8' }, { key: 'fake9', value: 'fake9' }, { key: 'fake10', value: 'fake10' }, { key: 'fake11', value: 'fake11' }, { key: 'fake12', value: 'fake12' }, { key: 'fake13', value: 'fake13' }, { key: 'fake14', value: 'fake14' }, { key: 'fake15', value: 'fake15' }]
  visibleReboot = false
  visible = false
  dialogTask = null
  detailTab = 'speedtest-new'
  detailSections = [
    { key: 'speedtest-new', label: 'Speedtest (new)' },
    { key: 'speedtest-old', label: 'Speedtest (old)' },
    { key: 'tasks', label: 'vManage Tasks' }
  ]
  hardware = signal<any[]>([])
  sensorsList = signal<any[]>([])
  /* async ngOnInit(): Promise<void> {
    const id = this.route.snapshot.paramMap.get('id')
    console.log(id)
    await this.getDeviceDetails(id)
  } */

  formatter (value) {
    return JSON.stringify(value, null, 2)
  }

  deviceMap = signal<any[]>([])
  refreshData (value) {
    this.switchPorts = []
    this.ports3_4.set([])
    this.gigabitPorts.set([])
    this.ciscoEdge.set(null)
    this.orgChart.set([])
    this.rawData.set([])
    this.hardware.set([])
    this.sensorsList.set([])
    this.IndirizzamentoSwitch.set('')
    this.Marca.set('')
    this.deviceMap.set([])
    this.chartOptionBanda.set({})
    this.hasTrafficData.set(false)
    this.isTrafficLoading.set(true)
    this.maxRX.set('')
    this.maxTX.set('')
    if (this.mySelect) {
      this.mySelect.nativeElement.value = '1'
      this.timeRangeMode = '1'
      this.startTime = ''
      this.endTime = ''
    }
    this.getDeviceDetails(value)
  }

  showTaskDialog (task) {
    task.activity_data = task.Payload?.activity || (task.Payload?.data ? task.Payload.data[0]?.activity : []) || []
    this.dialogTask = task
    this.visible = true
  }

  overlayVisible = signal<boolean>(false)
  convertBytes (bytes: number): string {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    let i = Math.floor(Math.log(bytes) / Math.log(k))
    // Limite massimo: GB
    if (i > 3) {
      i = 3
    }
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
  }

  /**
   * Workaround Optimus: la direttiva `pAutoFocus` imposta l'attributo `autofocus`
   * su ogni `p-button` quando il valore è `undefined` (bug: controlla `=== false`).
   * Il browser esegue quindi l'auto-focus nativo sul primo pulsante del dialog,
   * che su pagine standalone (es. /sdwanmonitor) è a metà pagina, facendo
   * scorrere il contenuto. Riportiamo il contenuto in cima all'apertura.
   */
  onDialogShow (dialog: Dialog): void {
    dialog.maximize()

    const scrollTop = (): void => {
      const content = dialog.contentViewChild?.nativeElement as HTMLElement | undefined
      if (content) {
        content.scrollTop = 0
      }
    }

    scrollTop()
    setTimeout(scrollTop, 0)
  }

  scrollTo (element) {
    this.overlayVisible.set(true)

    setTimeout(() => {
      this.overlayVisible.set(false)
    }, 1500) // durata dell'effetto (puoi modificarla)

    if (this[element + 'Element']) {
      this[element + 'Element'].nativeElement.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      })
      this.highlightTable(element)
    }
  }

  highlightTable (element) {
    const table = this[element + 'Element'].nativeElement
    this.overlayVisible.set(true) // mostra overlay
    table.classList.add('focus-table')

    setTimeout(() => {
      table.classList.remove('focus-table')
      this.overlayVisible.set(false) // rimuove overlay
    }, 1500) // durata in millisecondi
  }

  deviceMapFn (obj: any): Array<{ key: string, value: any }> {
    if (!obj) return []
    const columnsOrder = [
      { key: 'reachability', header: 'Reachability' },
      { key: 'system-ip', header: 'System IP' },
      { key: 'uuid', header: 'UUID' },
      { key: 'host-name', header: 'Host Name' },
      { key: 'site-id', header: 'Site ID' },
      { key: 'site-name', header: 'Frazionario' },
      { key: 'uptime-date', header: 'Uptime Date' },

      { key: 'bfdSummary', header: 'BFD Sessions' },
      { key: 'controlConnections', header: 'Control Connections' },
      { key: 'state', header: 'State' },
      { key: 'state_description', header: 'State Desc.' },
      { key: 'version', header: 'Version' },
      { key: 'serial-number', header: 'Serial Number' },
      { key: 'board-serial', header: 'Board Serial' },
      { key: 'device-groups', header: 'Device Groups' },
      { key: 'device-model', header: 'Device Model' },
      { key: 'certificate-validity', header: 'Certificate' }

    ]
    const orderedObj = Object.keys(obj).sort((a, b) => {
      return columnsOrder.findIndex(col => col.key === a) - columnsOrder.findIndex(col => col.key === b)
    }).reduce((acc, key) => {
      acc[key] = obj[key]
      return acc
    }, {})

    return Object.entries(orderedObj).filter(([key]) => columnsOrder.find(col => col.key === key)).map(([key, value]) => ({ key, value, header: columnsOrder.find(col => col.key === key)?.header }))
  }

  buildCircuitsTree (circuits) {
    if (!Array.isArray(circuits)) return []
    const tree: TreeNode[] = []
    circuits.forEach((x: any) => {
      const circuito = {
        data: {
          name: x.color,
          health: x['circuit-health'] || '-'
        },
        children: []
      }
      // console.log(x)
      x.tunnels.forEach(y => {
        circuito.children.push({
          data: { name: y.remote_system_ip, health: y.health }
        })
      })
      tree.push(circuito)
    })
    return tree
  }

  convertDate (unix) {
    const conv = new Date(Number(unix))
    // convert to timezone Europe/Rome
    const options = { timeZone: 'Europe/Rome', hour12: false }
    const formattedDate = conv.toLocaleString('it-IT', options)
    // return formatted date in YYYY-MM-DD HH:mm:ss format
    const year = conv.getFullYear()
    const month = String(conv.getMonth() + 1).padStart(2, '0')
    const day = String(conv.getDate()).padStart(2, '0')
    const hours = String(conv.getHours()).padStart(2, '0')
    const minutes = String(conv.getMinutes()).padStart(2, '0')
    return `${year}-${month}-${day} ${hours}:${minutes}`
  }

  taskDetails (task) {

  }

  switchPorts: any[] = []
  gigabitPorts = signal<any[]>([])

  getTooltip (port: any): string {
    if (port.mac) {
      const macs = Object.entries(port.mac)
        .map(([mac, vlans]) => `MAC: ${mac}\nVLAN ID: ${(vlans as string[]).join(', ')}`)
        .join('\n\n')
      return `${port.porta}\n\n${macs || 'Nessun MAC associato'}`
    }
    if (port.macs) {
      const vlans = {}
      port.macs.forEach(m => {
        vlans[m.mac] = vlans[m.mac] ? [...vlans[m.mac], m.vlan] : [m.vlan]
      })
      const macs = Object.entries(vlans)
        .map(([mac, vlans]) => `MAC: ${mac}\nVLAN ID: ${(vlans as string[]).join(', ')}`)
        .join('\n\n')
      return `${port.porta}\n\n${macs || 'Nessun MAC associato'}`
    }
  }

  firstArray = signal<any[]>([])
  secondArray = signal<any[]>([])
  IndirizzamentoSwitch = signal<string>('')
  Marca = signal<string>('')
  ports3_4 = signal<any[]>([])
  async getDeviceDetails (deviceUUID: string) {
    this.messageService.add({ severity: 'info', detail: 'Loading device details, please wait...' })
    // console.log('Fetching details for device:', deviceUUID)
    // 5 sec delay
    // await new Promise(resolve => setTimeout(resolve, 5000))
    try {
      this.workflowApiService.getCiscoEdge_switchStatus(deviceUUID).subscribe(switchRes => {
        // console.log(switchRes)
        const ports = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52]
        const _switch = switchRes || { switch: [] }
        this.IndirizzamentoSwitch.set(_switch.IndirizzamentoSwitch || '')
        this.Marca.set(_switch.Marca || '')
        this.switchPorts = _switch.switch.filter(p => !p.porta.startsWith('X'))
        if (this.switchPorts.length > 0) {
          this.firstArray.set(ports.slice(0, this.switchPorts.length / 2))
          this.secondArray.set(ports.slice(this.switchPorts.length / 2, this.switchPorts.length))
          // console.log(this.firstArray, this.secondArray)
        }
        this.gigabitPorts.set(_switch.switch.filter(p => !p.porta.startsWith('X')))
      })
    } catch (e) {

    }
    try {
      this.workflowApiService.getCiscoEdge_port3_4_Status(deviceUUID).subscribe(switchRes => {
        // console.log(switchRes)
        this.ports3_4.set(switchRes.switch || [])
      })
    } catch (e) {

    }
    this.workflowApiService.getCiscoEdge(deviceUUID).subscribe(
      (response) => {
        // console.log(response)
        if (response.device) {
          Object.keys(response.device).forEach(key => {
            if (key == 'uptime-date' || key == 'lastupdated') {
              const conv = new Date(Number(response.device[key]))
              // console.log('Uptime date:', conv)
              response.device[key] = conv.toLocaleString('it-IT', { timeZone: 'Europe/Rome' })
            }
          })
        }

        response.device.bfdSummary = response.device.bfdSessionsUp + ' of ' + response.device.bfdSessions
        response.circuitTree = this.buildCircuitsTree(response.siteIdStatus[0].circuits)
        const tempOrg: TreeNode[] = [{
          expanded: true,
          type: 'person',
          styleClass: 'border-green',
          data: {
            name: response.device['host-name'] || 'Unknown'
          },
          children: []
        }]

        response.siteIdStatus[0].circuits.forEach(circuit => {
          const cc = response.controlConnections.filter(cc => cc['local-color'] === circuit.color)
          // console.log('Circuit:', circuit.color, 'CC:', cc)
          tempOrg[0].children.push({
            expanded: true,
            type: 'person',
            styleClass: 'border-blue',
            data: {
              name: circuit.color.toUpperCase()
            },
            children: cc.map(tunnel => ({
              expanded: true,
              type: 'person',
              styleClass: tunnel.state.toUpperCase() == 'UP' ? 'border-green' : 'border-red',
              data: {
                name: tunnel['peer-type'] == 'vsmart' ? 'Controller' + (tunnel['site-id'] - 4000000000) : 'vManage',
                title: tunnel.state.toUpperCase()
              }
            }))
          })
        })

        this.orgChart.set(tempOrg)
        this.ciscoEdge.set(response)
        this.deviceMap.set(this.deviceMapFn(response?.device))
        /* const payload: any = {};
    if (this.timeRange) {
      payload.last_n_hour = this.timeRange;
    } else {
      payload.start_time = this.startTime;
      payload.end_time = this.endTime;
    } */
        this.workflowApiService.getCiscoEdge_Traffic(deviceUUID, { last_n_hour: '1' }).subscribe({
          next: (response: CiscoEdgeTrafficResponse) => {
            this.setChartBandaOptions(response.data)
            this.hasTrafficData.set(!!(response.data && response.data.length))
            this.isTrafficLoading.set(false)
          },
          error: (error) => {
            this.hasTrafficData.set(false)
            this.isTrafficLoading.set(false)
            console.error('Error fetching traffic history:', error)
            this.messageService.add({ severity: 'error', detail: 'Error fetching traffic history' })
          }
        })
      },
      (error) => {
        console.error('Error fetching device details:', error)
        this.messageService.add({ severity: 'error', detail: 'Error fetching device details' })
      }
    )
    this.workflowApiService.getCiscoEdgeStatistics(deviceUUID).subscribe(
      (response) => {
        // console.log('Statistics response:', response)
        this.setChartOptions(response.systemStatistics)
      },
      (error) => {
        console.error('Error fetching device statistics:', error)
        this.messageService.add({ severity: 'error', detail: 'Error fetching device statistics' })
      }
    )
    this.workflowApiService.getCiscoEdgeHardware(deviceUUID).subscribe(
      (response) => {
        // console.log('Statistics response:', response)
        this.hardware.set(response.hardware || [])
        this.sensorsList.set(response.temperature?.filter(sensor => sensor['sensor-name'] == 'fan' || sensor['sensor-name'] == 'temperature').map(sensor => {
          return {
            icon: sensor['sensor-name'] == 'temperature' && sensor['vdevice-dataKey'].includes('CPU') ? 'fa fa-microchip' : sensor['sensor-name'] == 'fan' ? 'fa fa-fan' : 'fa fa-temperature-low',
            label: sensor['sensor-name'] == 'temperature' ? sensor.name.split('Temp: ')[1] : sensor.name.split('RPM: ')[1] + ' - RPM',
            value: sensor['current-reading'] + (sensor['sensor-name'] == 'temperature' ? '°' : '')
          }
        }) || [])
      },
      (error) => {
        // console.error('Error fetching device statistics:', error)
        // this.toastr.error('Error fetching device statistics')
      }
    )
  }

  goBack () {
    this.router.navigate(['/awpDashboardCisco/ciscoSummary']).then(success => {
      if (!success) { this.messageService.add({ severity: 'warn', detail: 'Error' }) }
    }).catch(err => console.log(err))
  }

  hardwareArray = computed(() => {
    const edge = this.ciscoEdge()
    if (!edge?.hardware) return []
    return Array.isArray(edge.hardware) ? edge.hardware : []
  })

  avgCPU = computed(() => {
    const data = this.rawData()
    return data.length ? Math.round(data.reduce((acc, curr) => acc + curr.cpu_system, 0) / data.length) : 0
  })
  avgRAM = computed(() => {
    const data = this.rawData()
    return data.length ? Math.round(data.reduce((acc, curr) => acc + Math.round((curr.mem_util * 100)), 0) / data.length) : 0
  })
  setChartOptions (rawData) {
    this.rawData.set(rawData || [])
    this.chartOption.set({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        top: '5%',
        left: 'center'
      },
      xAxis: {
        type: 'time',
        axisLabel: {
          formatter: (value) => {
            const date = new Date(value)
            return date.toLocaleTimeString()
          }
        }
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: (value) => `${value}%`
        }
      },
      series: [
        {
          name: 'CPU',
          type: 'bar',
          smooth: true,
          data: rawData.map(d => [d.entry_time, d.cpu_system]),
          barWidth: 10,
          markLine: {
            data: [{ type: 'average', name: 'Avg' }]
          },
          itemStyle: {
            borderRadius: 5,
            color: new graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#19549f' },
              { offset: 1, color: '#334155' }
            ])
          }
        },
        {
          name: 'Memory',
          type: 'line',
          smooth: true,
          data: rawData.map(d => [d.entry_time, Math.round(d.mem_util * 100)]),
          showAllSymbol: true,
          symbol: 'emptyCircle',
          symbolSize: 5
        }
      ]
    })
  }

  timeRange: string = '1'
  chartOptionBanda = signal<any>(null)
  maxRX = signal<string>('')
  maxTX = signal<string>('')
  timeRangeMode: string = '1'
  startTime: string = ''
  endTime: string = ''
  onTimeRangeModeChange (event: any): void {
    const selectedValue = event.target.value
    this.timeRangeMode = selectedValue
    this.startTime = ''
    this.endTime = ''
    if (selectedValue === 'custom') {
      return
    }
    this.loadBandwidthData()
  }

  applyCustomRange (startValue: string, endValue: string): void {
    if (!startValue || !endValue) {
      this.messageService.add({ severity: 'warn', detail: 'Select start and end date' })
      return
    }
    this.startTime = startValue
    this.endTime = endValue
    this.timeRangeMode = 'custom'
    this.loadBandwidthData()
  }

  loadBandwidthData (): void {
    const payload: any = {}
    if (this.timeRangeMode !== 'custom') {
      payload.last_n_hour = this.timeRangeMode
    } else if (this.startTime && this.endTime) {
      payload.start_time = this.startTime
      payload.end_time = this.endTime
    } else {
      return
    }
    this.isTrafficLoading.set(true)
    this.hasTrafficData.set(false)
    this.workflowApiService.getCiscoEdge_Traffic(this.deviceUUID, payload).subscribe({
      next: (response: CiscoEdgeTrafficResponse) => {
        this.setChartBandaOptions(response.data)
        this.hasTrafficData.set(!!(response.data && response.data.length))
        this.isTrafficLoading.set(false)
      },
      error: (error) => {
        this.hasTrafficData.set(false)
        this.isTrafficLoading.set(false)
        console.error('Error fetching traffic history:', error)
        this.messageService.add({ severity: 'error', detail: 'Error fetching traffic history' })
      }
    })
  }

  isTrafficLoading = signal<boolean>(false)
  hasTrafficData = signal<boolean>(false)
  setChartBandaOptions (data: CiscoEdgeTrafficItem[]): void {
    const formatKbps = (value: number, decimals = 2): string => {
      if (!value || value === 0) return '0 kbps'
      const units = ['kbps', 'Mbps', 'Gbps', 'Tbps']
      let unitIndex = 0
      let currentValue = value
      while (currentValue >= 1000 && unitIndex < units.length - 1) {
        currentValue /= 1000
        unitIndex++
      }
      return `${parseFloat(currentValue.toFixed(decimals))} ${units[unitIndex]}`
    }
    if (!data?.length) {
      this.chartOptionBanda.set(null)
      this.maxRX.set('0 kbps')
      this.maxTX.set('0 kbps')
      return
    }
    const FIXED_INTERFACES: Array<{ name: string, color: string }> = [
      { name: 'GigabitEthernet0/0/0', color: '#090ba8' },
      { name: 'GigabitEthernet0/0/1', color: '#8e59b6' },
      { name: 'GigabitEthernet0/1/7', color: '#eb8e76' },
      { name: 'Cellular0/2/0', color: '#45660f' }
    ]
    const grouped = data.reduce<Record<string, CiscoEdgeTrafficItem[]>>((acc, item) => {
      if (!acc[item.interface]) {
        acc[item.interface] = []
      }
      acc[item.interface].push(item)
      return acc
    }, {})
    Object.keys(grouped).forEach((iface) => {
      grouped[iface].sort((a, b) => a.entry_time - b.entry_time)
    })
    const availableInterfaces = new Set(Object.keys(grouped))
    const rxSeries = FIXED_INTERFACES.map((iface) => ({
      name: iface.name,
      type: 'line',
      xAxisIndex: 0,
      yAxisIndex: 0,
      smooth: false,
      showSymbol: true,
      symbol: 'circle',
      symbolSize: 6,
      itemStyle: {
        color: iface.color
      },
      lineStyle: {
        color: iface.color,
        width: 2
      },
      emphasis: {
        focus: 'series'
      },
      data: (grouped[iface.name] || []).map(item => [item.entry_time, item.rx_kbps])
    }))
    const txSeries = FIXED_INTERFACES.map((iface) => ({
      name: iface.name,
      type: 'line',
      xAxisIndex: 1,
      yAxisIndex: 1,
      smooth: false,
      showSymbol: true,
      symbol: 'circle',
      symbolSize: 6,
      itemStyle: {
        color: iface.color
      },
      lineStyle: {
        color: iface.color,
        width: 2
      },
      emphasis: {
        focus: 'series'
      },
      data: (grouped[iface.name] || []).map(item => [item.entry_time, item.tx_kbps])
    }))
    const rawMaxRX = Math.max(...data.map(item => item.rx_kbps || 0))
    const rawMaxTX = Math.max(...data.map(item => item.tx_kbps || 0))
    this.maxRX.set(formatKbps(rawMaxRX))
    this.maxTX.set(formatKbps(rawMaxTX))
    const buildTooltip = (params: any[]): string => {
      if (!params?.length) return ''
      const axisValue = params[0].axisValue
      const date = new Date(axisValue)
      const rxMap: Record<string, number> = {}
      const txMap: Record<string, number> = {}
      params.forEach((p) => {
        const iface = p.seriesName
        const value = Array.isArray(p.value) ? p.value[1] : p.value
        if (p.seriesIndex < FIXED_INTERFACES.length) {
          rxMap[iface] = value
        } else {
          txMap[iface] = value
        }
      })
      let html = `
      <div class="min-w-[240px]">
        <div class="font-semibold mb-2">
          ${date.toLocaleString('it-IT')}
        </div>
    `
      FIXED_INTERFACES.forEach((iface) => {
        if (!availableInterfaces.has(iface.name)) {
          return
        }
        const rx = rxMap[iface.name] ?? 0
        const tx = txMap[iface.name] ?? 0
        html += `
        <div class="flex items-center mb-1.5">
          <span class="inline-block w-[10px] h-[10px] rounded-full bg-[${iface.color}] mr-2"></span>
          <span class="flex-1 font-medium">${iface.name}</span>
        </div>
        <div class="pl-[18px] mb-2 text-[#334e68]">
          RX: <b>${formatKbps(rx)}</b><br/>
          TX: <b>${formatKbps(tx)}</b>
        </div>
      `
      })

      html += '</div>'
      return html
    }
    this.chartOptionBanda.set({
      backgroundColor: '#fff',
      color: FIXED_INTERFACES.map(i => i.color),
      axisPointer: {
        link: [
          {
            xAxisIndex: 'all'
          }
        ]
      },
      tooltip: {
        confine: true,
        trigger: 'axis',
        axisPointer: {
          type: 'line',
          lineStyle: {
            color: '#9aa5b1',
            type: 'dashed'
          }
        },
        backgroundColor: 'rgba(255,255,255,0.97)',
        borderColor: '#d9e2ec',
        borderWidth: 1,
        textStyle: {
          color: '#334e68'
        },
        extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.08);',
        formatter: buildTooltip
      },
      legend: {
        type: 'scroll',
        left: 'center',
        top: 0,
        icon: 'circle',
        itemGap: 14,
        textStyle: {
          color: '#3e4c59',
          fontSize: 12
        },
        formatter: (name: string) => name.replace('GigabitEthernet', 'Gi').replace('Cellular', 'Cell'),
        data: FIXED_INTERFACES.map(i => i.name),
        selected: FIXED_INTERFACES.reduce<Record<string, boolean>>((acc, i) => {
          acc[i.name] = availableInterfaces.has(i.name) // true se presente nei dati
          return acc
        }, {})
      },
      grid: [
        {
          left: 70,
          right: 90,
          top: 40,
          height: 140,
          containLabel: true
        },
        {
          left: 70,
          right: 90,
          top: 240,
          height: 140,
          containLabel: true
        }
      ],
      xAxis: [
        {
          type: 'time',
          gridIndex: 0,
          boundaryGap: false,
          axisLine: {
            lineStyle: { color: '#cbd2d9' }
          },
          axisTick: { show: false },
          axisLabel: { show: false },
          splitLine: { show: false }
        },
        {
          type: 'time',
          gridIndex: 1,
          boundaryGap: false,
          axisLine: {
            lineStyle: { color: '#cbd2d9' }
          },
          axisTick: { show: false },
          axisLabel: {
            color: '#616e7c',
            fontSize: 12,
            margin: 12,
            rotate: 25,
            formatter: (value: number) => {
              const d = new Date(value)
              return d.toLocaleString('en-US', {
                month: 'short',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
              })
            }
          },
          splitLine: { show: false }
        }
      ],
      yAxis: [
        {
          type: 'value',
          gridIndex: 0,
          min: 0,
          name: 'Rx Kbps',
          nameLocation: 'end',
          nameRotate: 0,
          nameTextStyle: {
            color: '#52606d',
            padding: [0, 0, 8, -28]
          },
          axisLabel: {
            color: '#616e7c'
          }
        },
        {
          type: 'value',
          gridIndex: 1,
          min: 0,
          name: 'Tx Kbps',
          nameLocation: 'end',
          nameRotate: 0,
          nameTextStyle: {
            color: '#52606d',
            padding: [0, 0, 8, -28]
          },
          axisLabel: {
            color: '#616e7c'
          }
        }
      ],
      dataZoom: [
        {
          id: 'dataZoomX',
          type: 'slider',
          xAxisIndex: [0, 1],
          filterMode: 'filter',
          start: 0,
          end: 100,
          height: 18,
          bottom: 10,
          labelFormatter: () => ''
        },
        {
          type: 'inside',
          xAxisIndex: [0, 1],
          filterMode: 'filter'
        }
      ],
      series: [...rxSeries, ...txSeries]
    })
  }
}
@NgModule({
  imports: [OptimUiSharedModule, MessageModule, FormsModule, CommonModule, NgxEchartsModule.forRoot({ echarts }), DialogModule, BadgeModule, TableModule, PanelModule, TreeTableModule, OrganizationChartModule, ProgressBarModule, FieldsetModule, MenuModule, ButtonModule, SkeletonModule, DockModule, speedTestModule, TooltipModule, FuseqTableComponent, SpeedtestHistoryTableComponent, FontAwesomeModule, CiscoDetailsComponent],
  exports: [CiscoDetailsComponent]
})
export class ciscoEdgeModule { }
